module.exports = __webpack_public_path__ + "static/lucia_portrait-2a2c6ba9487a7867e09e4621c383c0f2.jpg";